import TextFieldMixin from 'trunks/vue/share/components/fields/text_field.js';
import FieldMixinForResponse from './mixin.js';

const TextFieldForResponse = {
  mixins: [
    FieldMixinForResponse,
    TextFieldMixin
  ],

  template: `
    <Field :field='field'
           v-show='visible'
           :extendClass='[fieldCommonClass, fieldDifferenceClass]'
           :message='errorMsg'>
      <template slot='input'>
        <input class='form-field-value'
               type="text"
               v-model.trim='value'
               :readonly='!editing'
               :placeholder='placeholder'
               :disabled="disabled"
               @input.stop.prevent='userInput'
               ref='input' />
      </template>
    </Field>
  `,

  computed: {
    placeholder: function() {
      return this.field.placeholder || '请输入';
    },

    disabled: function() {
      return this.field.disabled;
    }
  }
};

export default TextFieldForResponse;
